var _path, _path2, _rect, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDsOverlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 360,
    viewBox: "0 0 960 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5H479.5V359.5H5.00001C2.51473 359.5 0.5 357.485 0.5 355V5C0.5 2.51472 2.51472 0.5 5 0.5Z",
    fill: "#D3D3D3",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480.5 0.5H955C957.485 0.5 959.5 2.51472 959.5 5V355C959.5 357.485 957.485 359.5 955 359.5H480.5V0.5Z",
    fill: "#D3D3D3",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 115,
    fill: "black",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240 225C277.294 225 307.5 194.794 307.5 157.5C307.5 120.206 277.294 90 240 90C202.706 90 172.5 120.206 172.5 157.5C172.5 194.794 202.706 225 240 225ZM240 258.75C194.944 258.75 105 281.362 105 326.25V360H375V326.25C375 281.362 285.056 258.75 240 258.75Z",
    fill: "#474747"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsOverlay);
export default __webpack_public_path__ + "static/media/DS-overlay.47727e38b688bb1116f1969ddac91198.svg";
export { ForwardRef as ReactComponent };